import { createAPI } from '@common'
export default {
  getGroups: config => createAPI('customEncryptApiName-1/0w20hspvqt', 'GET', config),
  getMamGroupTemplatesSystem: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ufnqmbuft0tztufn', 'GET', config), // 读所有模板, type 整数，模板类型，0表示视频模板，1表示音频模板。默认为0
  getMamGroupTemplates: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ufnqmbuft', 'GET', config), // group 整数，分组id
  // deleteMamGroupTemplates: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ufnqmbuft', 'DELETE', config), // 删除分组
  /*
   site 整数，所属站点ID
   code 字符串，所属分组类型的编码, 有 video audio photo 等
   name 字符串，分组名称；
   group 整数，分组ID。说明：可选参数，当参数为空时，视为新增一个分组
   templates 字符串数组，启用的模板的ID的数组，如["S-001","S-002"]（禁用的就从数组中去掉即可）；
   defaults 字符串，默认播放模板的ID，如"S-001"。每组最多只有一个默认播放模板；
   */

   // 添加分类（分组）
  postMamGroupTempNew: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0ofx', 'POST', config),
  // 修改分类（分组）
  postMamGroupTempUpdate: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0vqebuf', 'POST', config),
  // 删除分类（分组）
  postMamGroupTempDel: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0efm', 'GET', config),
  // 获取分组详情
  getMamGroupTempDetail: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0efubjm', 'GET', config), 
  // 获取分组下素材数量
  getMamGroupMaterialCount: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0nbufsjbm0dpvou', 'GET', config),
  /* postMamGroupTempNew: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ofx', 'POST', config), // 新建分组
  postMamGroupTempUpdate: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0vqebuf', 'POST', config), // 修改分组
  postMamGroupTempDel: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0efm', 'POST', config), // 删除分组
  getMamGroupTempDetail: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0efubjm', 'GET', config), // 获取分组详情
  getMamGroupMaterialCount: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0nbufsjbm0dpvou', 'GET', config), // 获取分组下素材数量
  */
  getMamGroupTempName: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0obnf', 'GET', config), // 获取分组名称

  postMamGroupTemplates: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ufnqmbuft', 'POST', config),
  putMamGroupTemplates: config => createAPI('customEncryptApiName-1/0w20nbn0hspvq0ufnqmbuft', 'PUT', config),
  // 某分组人物数量
  getLeaderGroupCount: config => createAPI('customEncryptApiName-1/0w20mfbefs0hspvq0dpvou', 'GET', config),
  // 创建子分组
  postGroupNewByParent: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0ofxCzQbsfou', 'POST', config),
  // 分组重命名
  postGroupUpdateGroupName: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0hspvq0vqebufHspvqObnf', 'POST', config),
  // 移动音视频
  postMoveVideo: config => createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0npwf', 'POST', config),
}

